/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Selfhost_S3Inputs */

const en_fc_online_selfhost_s3 = /** @type {(inputs: Fc_Online_Selfhost_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open http://localhost:8765 in Chrome, Edge or another WebGPU-capable browser.`)
};

/**
* | output |
* | --- |
* | "Open http://localhost:8765 in Chrome, Edge or another WebGPU-capable browser." |
*
* @param {Fc_Online_Selfhost_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_selfhost_s3 = /** @type {((inputs?: Fc_Online_Selfhost_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Selfhost_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_selfhost_s3(inputs)
});
export { fc_online_selfhost_s3 as "fc.online.selfhost.s3" }